
<template>
    <div>
        <div class="main-wrapper">
            <layout-header @changedLanguage="changedLanguage"></layout-header>
            <layout-navbar></layout-navbar>
           <!-- Page Wrapper -->
           <div class="page-wrapper">

              <!-- Page Content -->
              <div class="content container-fluid">

                <div class="crms-title row bg-white">
                    <div class="col  p-0">
                        <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('menu.gap_analysis') }} </h3>
                    </div>
                    <div class="col p-0 text-right">
                        <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                            <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                            <li class="breadcrumb-item active">{{ $t('menu.gap_analysis') }}</li>
                        </ul>
                    </div>
                </div>

                <!-- Page Header -->
                <div class="page-header pt-3 mb-0 ">
                    <div class="row">
                        <div class="col-2">
                            <div class="dropdown">
                                <a class="dropdown-toggle recently-viewed" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
                                  {{ $t('all_entries') }}</a>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="#" @click="showGaps($event, 'all')">{{ $t('all_entries') }}</a>
                                    <a class="dropdown-item" href="#" @click="showGaps($event, 'a')">Prio A</a>
                                    <a class="dropdown-item" href="#" @click="showGaps($event, 'b')">Prio B</a>
                                    <a class="dropdown-item" href="#" @click="showGaps($event, 'c')">Prio C</a>
                                    <a class="dropdown-item" href="#" @click="showGaps($event, 'd')">Prio D</a>
                                </div>
                            </div>
                        </div>
                      <div class="col-2">
                        <div class="dropdown">
                          <a class="dropdown-toggle recently-viewed" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
                            {{ $t('relevant_entries') }}</a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#" @click="showGaps($event, 'relevant')">{{ $t('relevant_entries') }}</a>
                            <a class="dropdown-item" href="#" @click="showGaps($event, 'irrelevant')">{{ $t('irrelevant_entries') }}</a>
                          </div>
                        </div>
                      </div>
                        <div class="col-8 text-right">
                            <ul class="list-inline-item pl-0">
                              <li class="list-inline-item">
                                <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                              </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /Page Header -->

                <!-- Content Starts -->
                <DataTableDSMS
                  ref="dataTableDSMS"
                  title="GAP Analyse"
                  fileName="GAP_Analyse"
                  modelName="question"
                  deleteURL="todos/v1/delete_question/"
                  :extraActions="extraActions"
                  :editorPatchURL="editorPatchURL"
                  :columns="columns"
                  :objects="question_list"
                  :exportColumns="[0, 1, 9]"
                  :allowDelete="false"
                  :initCallbackFunctions="initCallbackFunctions"
                  @tableCreated="setTable"
                  @editorCreated="setEditor"
                  @showObject="showQuestionSurvey"
                  @callDrawback="drawCallbackFunctions"
                  v-if="question_list.length > 0"
                ></DataTableDSMS>
                <FingerPrintSpinner v-show="question_list.length <= 0" color="#9b3136" :size="300" :container-padding="100" />
                <!-- /Content End -->

              </div>
              <!-- /Page Content -->

              </div>
        <!-- /Page Wrapper -->
        </diV>

		<!--modal section starts here-->
          <!-- Modal -->
      <task :currentTodo="currentTodo" :origin="currentTodo.model" @todoUpdated="updateTodo">
        <template v-slot:works>
          <Work
            :current-todo="currentTodo"
            @workUpdated="patchTodoWorks"
          ></Work>
        </template>
        <template v-slot:steps>
          <Steps
            :totalSteps="currentTodo.steps"
            :taskID="currentTodo.id"
            @stepsUpdated="setSteps"
          ></Steps>
        </template>
      </task>
      <GAP :currentGap="currentGap" :taskReturnGap="taskReturnGap" @gapUpdated="updateGap" @openTaskModal="openTask"></GAP>
      <GAPSurvey :currentGap="currentGap" v-if="currentGap"></GAPSurvey>
      <modal width="600px" v-show="openAnswer" @close="openAnswer=false">
        <template v-slot:header><h4>{{ $t('gap_status_entry') }}</h4></template>
        <template v-slot:body>
          <new-gap-stand-component :current-answer="new_answer" @standUpdated="patchAnswer" :currentGapContent="currentGapContent" v-if="currentGap" :current-gap="currentGap"></new-gap-stand-component>
        </template>
        <template v-slot:footer><div></div></template>
      </modal>

    </div>
</template>
<script>
  import { service, baseURL } from '@/utils/request.js';
  import {noCacheURL, deepCopy} from '@/utils/index.js';
  import {mapMutations, mapState} from 'vuex';
  import task from "@/components/component/TodoComponent.vue";
  // import $ from 'jquery'
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';
  import {objectModalName, newTodo, newQuestion, newAnswer} from '@/utils/enums'
  import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
  import Steps from "@/components/component/Steps.vue";
  import GAP from "@/components/component/GapComponent.vue";
  import GAPSurvey from "@/components/component/GapSurveyComponent.vue";
  import AnswerComponent from "@/components/component/AnswerComponent.vue";
  import Modal from "@/components/component/Modal.vue";
  import NewGapStandComponent from "@/components/component/NewGapStandComponent.vue";
  import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
  import Work from "@/components/component/WorksComponent.vue";
  import FingerPrintSpinner from '@/components/component/FingerPrintSpinner'


	export default {
	  components: {
      Work,FingerPrintSpinner,
      NewGapStandComponent, DisplayColumnsComponent, AnswerComponent, Steps, task, DataTableDSMS, GAP, GAPSurvey, Modal},
	  data() {
	    return {
	      question_list: [],
        newGap: true,
        openAnswer: false,
        taskReturnGap: false,
        newComment: '',
        datetimeOptions: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
        },
        editorPatchURL: '/todos/v1/patch_answer/',
        newQuestionID: null,
        new_answer: newAnswer,
        new_question: newQuestion,
        currentGap: newQuestion,
        original_answers: [],
        current_survey: '',
        help_text: '',
        table: null,
        editor: null,
        irrelevantQuestions: [{id: null, text: '---'}],
        currentTodo: newTodo,
        createCloseTask: false
      }
    },
    validations() {
      return {
        currentGap: {
          description: {required, $lazy: true}
        },
        newQuestionID: {required, $lazy: true},
      }
    },
    setup() {
      return {
        v$: useVuelidate()
      }
    },
    created() {
    },
    computed: {
	    ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id, language: state => state.app.language}),
      currentGapContent() {
        if (this.language === 'de') return this.currentGap.description;
        return this.currentGap.description_en;
      },
      columns() {
        const language_postfix = this.language === 'de' ? '' : '_en';
        const noEntry = this.$t('no_entry');
        return [
        {
          label: 'Nr.#',
          name: 'sequence',
          enableEditor: false,
          definition: {data: "sequence", width: '50px'},
        },
        {
          label: this.$t('old_number'),
          name: 'old_intern_number',
          enableEditor: false,
          definition: { data: "old_intern_number", width: "5%" },
        },
        {
          label: this.$t('new_number'),
          name: 'new_intern_number',
          enableEditor: false,
          definition: { data: "new_intern_number", render: (data, type, row) => data == null ? '-' : `<a href="#" class="q-old-internal-number" data-question-id="${row.id}">${data}</a>`, width: "5%"},
        },
        {
          label: this.$t('questionnaire'),
          name: `description${language_postfix}`,
          enableEditor: false,
          definition: { data: `description${language_postfix}`, width: "20%" },
        },
        {
          label: 'PRIO',
          name: 'priority',
          enableEditor: false,
          definition: { data: "priority", width: "5%" },
        },
        {
          label: this.$t('gdpr_requirement'),
          name: 'category',
          enableEditor: false,
          definition: { data: "category", width: "10%" },
        },
        {
          label: this.$t('actual_status'),
          name: 'last_answer.question_answer',
          enableEditor: false,
          definition: { data: null, render: function(data) {
              if (Object.keys(data.last_answer).length > 0) return `<span class='edit-answer' style="white-space: pre-line" data-question-id="${data.id}">${data.last_answer.question_answer}</span>`;
              return `<i class='edit-answer' data-question-id="${data.id}">${this.$t('no_entry')}</i>`
            }.bind(this), width: "20%" },
        },
        {
          label: this.$t('task'),
          name: 'tasks',
          enableEditor: false,
          filterStyle: '<select class="form-control self-managed-filter gap-task-filter" style="height: 30px!important;"></select>',
          definition: { data: null, render: function(data) {
              let html = '<div class="pipeline-small flat dkl-task">';
              let item_class = 'noselect tipped-top planing';
              for (let i = 0; i < data.tasks.length; i++) {
                if (data.tasks[i].status === 'Abgeschlossen') item_class = 'closed noselect tipped-top'
                else if (data.tasks[i].status === 'Offen') item_class = 'open noselect tipped-top planing'
                else if (data.tasks[i].status === 'In Bearbeitung') item_class = 'processing noselect tipped-top planing'
                else item_class = 'noselect tipped-top planing'
                html += `<a class="${item_class} single-task z-index-0 mr-1 mb-1" data-task-id="${data.tasks[i].id}" href="#" data-question-id="${data.id}" data-toggle="tooltip" data-placement="top" title="${data.tasks[i].description}" data-original-title="${data.tasks[i].description}">&nbsp;
                      <span class="stretched-link"  data-task-id="${data.tasks[i].id}" data-question-id="${data.id}"></span>
                    </a>`
              }
              html += '</div>';
              return html
            }, width: "20%"},
        },
        {
          label: 'Status',
          name: 'state',
          enableEditor: false,
          filterStyle: 'dropdown',
          definition: { data: null, render: (data)=> {
              let status = `<span class="dkl-bg-abgeschlossen">${this.$t('task_status.completed')}</span>`;
              if (!data.relevant) {
                status = `<span class="dkl-bg-others">${this.$t('task_status.not_applicable')}</span>`
                return status
              }
              if (Object.keys(data.last_answer).length === 0) {
                status = `<span class="dkl-bg-offen">${this.$t('task_status.open')}</span>`
                return status
              }
              for (let i = 0; i < data.tasks.length; i++) {
                if (data.tasks[i].status.includes('Offen')) {
                  status = `<span class="dkl-bg-offen">${this.$t('task_status.open')}</span>`
                  break
                }
              }
              return status
            }, width: "5%"},
        },
        {
          label: this.$t('document'),
          name: 'last_answer.document',
          enableEditor: false,
          definition: { data: null, render: function(data) {
              if (Object.keys(data.last_answer).length > 0) return `<span class='edit-answer' style="white-space: pre-line" data-question-id="${data.id}">${data.last_answer.document ? data.last_answer.document : ''}</span>`;
              return `<i class='edit-answer' data-question-id="${data.id}">${this.$t('no_entry')}</i>`
            }.bind(this), width: "13%" },
        },
        {
          label: 'ISMS relevant',
          name: `isms_matching${language_postfix}`,
          enableEditor: false,
          definition: { data: `isms_matching${language_postfix}`, visible: false, width: "5%" },
        },
        {
          label: this.$t('modified'),
          name: 'modified',
          enableEditor: false,
          definition: { data: "modified", width: "5%", render: (data, type, row) => {
              if (Object.keys(row.last_answer).length > 0 ) {
                return row.last_answer.modified
              }
              return data
            }},
        },
      ]},
    },
    async mounted() {
      await this.getQuestions()
    },
    updated ()
    {

      // Date Time Picker

      if ($('.datetimepicker').length > 0) {
        $('.datetimepicker').datetimepicker({
          format: 'DD/MM/YYYY',
          icons: {
            up: "fa fa-angle-up",
            down: "fa fa-angle-down",
            next: 'fa fa-angle-right',
            previous: 'fa fa-angle-left'
          }
        });
      }
    },
    methods: {
      ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
      async changedLanguage() {
        this.$nextTick(async () => {
          const selectDom = $('.dkl-status-select');
          if (selectDom.length > 0) {
            selectDom.off('change');
            selectDom.empty();
          }
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      setTable(table) {
        this.table = table
        $('.gap-task-filter').val('Offen').trigger('change')
      },
      setEditor(editor) {
        this.editor = editor
      },
      setSteps(steps) {
        this.currentTodo.steps = steps
      },
      openNewTask() {
        this.currentTodo = deepCopy(newTodo)
        this.currentTodo.model = 'question'
        this.currentTodo.origin = 'question'
        this.currentTodo.object_id = this.currentGap.id
        this.currentTodo.question = this.currentGap.id
        this.currentTodo.priority = this.currentGap.priority
        this.setEdit(true)
        $('#' + objectModalName.task).modal('show')
      },
      openTask() {
        $('#' + objectModalName.question).modal('hide')
        this.openNewTask()
        this.taskReturnGap = true
      },
      patchAnswer(answerObject, generateTask) {
        if (this.currentGap.last_answer.id !== answerObject.id) {
          this.currentGap.answers.push(answerObject)
        } else {
          const answerIndex = this.currentGap.answers.findIndex(answer => answer.id === answerObject.id)
          this.currentGap.answers[answerIndex] = answerObject
        }
        this.currentGap.last_answer = answerObject
        this.currentGap.last_answer.question_answer = answerObject.comments
        const gapIndex = this.question_list.findIndex(question => question.id === this.currentGap.id)
        this.question_list[gapIndex] = this.currentGap
        this.table.clear().rows.add(this.question_list).draw()
        this.openAnswer = false
        if (this.createCloseTask) {
          const today = new Date()
          service.request({
            url: `/todos/v1/save_task/`,
            method: 'POST',
            responseType: 'json',
            data: {
              id: null,
              description: answerObject.comments,
              modified_by: this.userName,
              customer: this.accountid,
              model: 'question',
              object_id: this.currentGap.id,
              status: 'Annulliert',
              due_date: today.toISOString().split('T')[0],
              priority: 'Prio D'
            }
          }).then((response) => {
            this.currentGap.tasks.push(response.data)
            this.question_list[gapIndex] = this.currentGap
            this.table.clear().rows.add(this.question_list).draw()
            this.$vToastify.success('Maßnahme mit Status "Annulliert" wird erfolgreich erstellt!')
          })
        }
        if (generateTask) this.openNewTask()
      },
      updateTodo(todoObject) {
        const todoIndex = this.currentGap.tasks.findIndex(todo => todo.id === todoObject.id)
        if (todoIndex === -1) {
          this.currentGap.tasks.push(todoObject)
        } else {
          this.currentGap.tasks[todoIndex] = todoObject
        }
        const gapIndex = this.question_list.findIndex(question => question.id === this.currentGap.id)
        this.question_list[gapIndex] = this.currentGap
        this.table.clear().rows.add(this.question_list).draw()
        $('#' + objectModalName.task).modal('hide')
        this.$vToastify.success('Maßnahme ist erfolgreich gespeichert!')
        if (this.taskReturnGap) {
          this.setModalDirty(true)
          $('#' + objectModalName.question).modal('show')
        }
        this.taskReturnGap = false
      },
      updateGap(gapObject, generateTask) {
        const questionIndex = this.question_list.findIndex(question => question.id === gapObject.id)
        if (questionIndex === -1) {
          this.question_list.push(gapObject)
        } else {
          this.question_list[questionIndex] = gapObject
        }
        this.table.clear().rows.add(this.question_list).draw()
        this.$vToastify.success('Iststand für den GAP Eintrag ist erfolgreich gespeichert!')
        if (generateTask) this.openTask()
      },
      extraActions(data) {
        return `<a class="dropdown-item close-gap" href="#" data-object-id="${data.id}">abschliessen mit Besonderheiten</a><a class="dropdown-item irrelevant-gap" href="#" data-object-id="${data.id}">"relevant" status ändern</a>`
      },
      initCallbackFunctions(api) {
        const taskDropdown = $('.gap-task-filter')
        taskDropdown.empty()
        taskDropdown.append(new Option('-----', 'all'))
        taskDropdown.append(new Option('Offen', 'Offen'))
        taskDropdown.append(new Option('In Bearbeitung', 'In Bearbeitung'))
        taskDropdown.append(new Option('Abgeschlossen', 'Abgeschlossen'))
        taskDropdown.append(new Option('Annulliert', 'Annulliert'))
        const that = this
        taskDropdown.off('change').on('change', () => {
          const taskState = taskDropdown.val()
          let filteredQuestionList = that.question_list.map((question) => {
            let newQuestion = deepCopy(question)
            newQuestion.tasks = newQuestion.tasks.filter(task => taskState === 'all' || task.status === taskState)
            return newQuestion
          })
          that.table.clear().rows.add(filteredQuestionList).draw()
        })
      },
      drawCallbackFunctions() {
        const that = this
        $('.edit-answer').off('click').on('click', function(e) {
          e.preventDefault()
          that.createCloseTask = false
          const questionID = $(e.target).data('question-id');
          that.currentGap = that.question_list.filter(question => question.id === questionID)[0]
          const dateFormatOptions = {day: '2-digit', month: '2-digit', year: 'numeric'}
          const language_postfix = that.language === 'de' ? '' : '_en'
          if (that.currentGap.last_answer) {
            that.new_answer = that.currentGap.last_answer
            that.new_answer.modified_by = that.userID
            that.new_answer.comments = that.new_answer.question_answer
            that.new_answer.question = that.currentGap.id
          } else {
            that.new_answer = deepCopy(newAnswer)
            that.new_answer.question = that.currentGap.id
            that.new_answer.modified_by = that.userID
          }
          that.new_answer.yes = that.currentGap[`statement_yes${language_postfix}`]
          that.new_answer.no = that.currentGap[`statement_no${language_postfix}`]
          that.new_answer.partial = that.currentGap[`statement_partial${language_postfix}`]
          if (!that.new_answer.stand) that.new_answer.stand = new Date().toLocaleDateString('de', dateFormatOptions)
          that.openAnswer = true
        })
        $('.q-old-internal-number').off('click').on('click', function(e) {
          e.preventDefault();
          const objectId = $(e.target).data('question-id');
          that.currentGap = that.question_list.filter(question => question.id === objectId)[0]
          $('#' + objectModalName.question).modal('show');
        })
        $('.irrelevant-gap').off('click').on('click', function(e) {
          e.preventDefault()
          const objectId = $(e.target).data('object-id');
          const currentGap = that.question_list.filter(question => question.id === objectId)[0]
          service.request({
            url: `/todos/v1/patch_question/${objectId}/`,
            method: 'PUT',
            responseType: 'json',
            data: {
              id: objectId,
              relevant: !currentGap.relevant,
              modified_by: that.userID
            }
          }).then((response) => {
            const gapIndex = that.question_list.findIndex(question => question.id === response.data.id)
            that.question_list[gapIndex] = response.data
            that.table.clear().rows.add(that.question_list).draw()
            that.$vToastify.success('GAP Eintrag ist als nicht zutreffend markiert!')
          })
        })
        $('.single-task').off('click').on('click', function(e) {
          e.preventDefault();
          const taskID = $(e.target).data('task-id');
          const gapID = $(e.target).data('question-id');
          that.currentGap = that.question_list.filter(question => question.id === gapID)[0]
          service.request({
            url: `todos/v1/get_task/${taskID}/`,
            method: 'GET',
            responseType: 'json'
          }).then((response)=>{
            that.currentTodo = response.data;
            $('#' + objectModalName.task).modal('show');
          })
        })
        $('.close-gap').off('click').on('click', function(e) {
          e.preventDefault()
          const objectId = $(e.target).data('object-id');
          that.currentGap = that.question_list.filter(question => question.id === objectId)[0]
          that.new_answer = deepCopy(newAnswer)
          that.new_answer.question = that.currentGap.id
          that.new_answer.modified_by = that.userID
          that.createCloseTask = true
          that.openAnswer = true
        })
      },
      addNewGap() {
        this.currentGap = deepCopy(newQuestion)
        $('#' + objectModalName.question).modal('show')
      },
      showGaps(e, target) {
        e.preventDefault()
        if (target === 'all') this.table.clear().rows.add(this.question_list).draw()
        if (target === 'a') this.table.clear().rows.add(this.question_list.filter((task) => task.priority === 'Prio A')).draw()
        if (target === 'b') this.table.clear().rows.add(this.question_list.filter((task) => task.priority === 'Prio B')).draw()
        if (target === 'c') this.table.clear().rows.add(this.question_list.filter((task) => task.priority === 'Prio C')).draw()
        if (target === 'd') this.table.rows.add(this.question_list.filter((task) => task.priority === 'Prio D')).draw()
        if (target === 'relevant') {
          this.getQuestions(() => this.table.clear().rows.add(this.question_list).draw())
        }
        if (target === 'irrelevant') {
          this.getIrrelevantQuestions(() => this.table.clear().rows.add(this.question_list).draw())
        }
        $(e.target).parents(".dropdown").find('.dropdown-toggle').text($(e.target).text());
      },
      async getQuestions(callback = () => {}) {
        service.request({
          url: `todos/v1/questions/${this.accountid}/?cb=${Date.now()}`,
          method: 'GET',
          responseType: 'json',
        }).then((response) => {
          this.question_list = response.data;
          callback()
        }).catch(function(err) {
          console.log(err)
        })
      },
      async getIrrelevantQuestions(callback = () => {}) {
        service.request({
          url: `todos/v1/irrelevant_questions/${this.accountid}/?cb=${Date.now()}`,
          method: 'GET',
          responseType: 'json',
        }).then((response) => {
          this.question_list = response.data;
          callback()
        }).catch(function(err) {
          console.log(err)
        })
      },
      showQuestionSurvey(question_id) {
        this.currentGap = this.question_list.filter(x => x.id === question_id)[0];
        $("#" + objectModalName.question).modal('show')
      },
      async patchTodoWorks(patchTodo) {
        service.request({
          url: `todos/v1/patch_task/${patchTodo.id}/`,
          method: 'PUT',
          responseType: 'json',
          data: {
            id: patchTodo.id,
            crm_works: patchTodo.crm_works,
          }
        }).then((response) => {
          this.$vToastify.success('Aufwand ist erfolgreich gespeichert!')
        }).catch(function(err) {
          console.log(err)
        })
      },
    }
	}
</script>
<style>
</style>
